import { boolean, object, array, string, mixed } from 'yup';

const makeSchema = data => {
  if (!data) return;
  let schema = {};

  for (let prop in data) {
    schema[prop] = boolean().test('checked', 'Required', value => {
      return value;
    });
  }

  schema = {
    ...schema,
    photo: mixed()
      // .required('You have to select photo!')
      .nullable()
      .test('photo', 'You have to select image file!', value => {
        return true;
        // if (value) return true;
        // return false;
      }),
    photo1: mixed()
      // .required('You have to select photo!')
      .nullable()
      .test('photo1', 'You have to select image file!', value => {
        return true;
        // if (value) return true;
        // return false;
      }),

    //old validation for spesc sheet files
    // file1: mixed().notRequired(),
    // file2: mixed().notRequired(),
    // file3: mixed().notRequired(),

    //validation for free atachment files
    attachmentFile1: mixed().notRequired(),
    attachmentFile2: mixed().notRequired(),
    attachmentFile3: mixed().notRequired(),
    attachmentFile4: mixed().notRequired(),
    attachmentFile5: mixed().notRequired(),
    attachmentFile6: mixed().notRequired(),
    attachmentFile7: mixed().notRequired(),

    //validation for spesc sheet files
    specificationSheets: array()
      .nullable()
      .test('hasValues', 'You have to select specification sheets!', value => {
        // return value.length > 0 ? true : false;
        return true;
      }),

    url: string()
      .required('URL is required field!')
      .url('URL is not valid!'),
    slipNote: string(),
    // .required('Note is required field!'),
    ies: mixed()
      .nullable()
      .test('ies', 'You have to select Photometric data or CAD file!', value => {
        // if (value) return true;
        // return false;
        return true;
      }),
  };

  return object().shape(schema);
};

export default makeSchema;
